import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Container, Box, Typography, Grid, Icon, Stack, Tooltip, IconButton, CardActions, CardContent, CardHeader, Card, CardMedia, Link, Button } from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GoToWebsiteIcon from '@mui/icons-material/OpenInBrowser';
import DocsIcon from '@mui/icons-material/MenuBook';
import PDFIcon from '@mui/icons-material/PictureAsPdf';
import PipIcon from '@mui/icons-material/ViewInAr';
import CoPresentIcon from '@mui/icons-material/CoPresent';

// @ts-ignore
import OrcidIcon from '../images/orcid_logo.svg';
// @ts-ignore
import GoogleScholarIcon from '../images/google_scholar_logo.svg';
// @ts-ignore
import RgIcon from '../images/researchgate_logo.svg';
// @ts-ignore
import slideIcon from '../images/zenodo.png';
import emailIcon from '../images/mail-142.png';

import CodeChip from '../components/CodeChip';
import { Title, Paragraph } from '../components/StyledComponents';
import { short_intro_text, about_me_text, projects, courses, supervising, skills, past_text, skillsCategories } from '../content';
import Seo from '../components/layout/seo';
import LinkOut from "../components/LinkOut";
import LinkPara from '../components/LinkPara';
import LinkLecture from '../components/LinkLecture';
import ProfileButton from "../components/ProfileButton";
import { FC } from '../utils/types';
// import MyMarkdown from "../components/MyMarkdown";
// import MyMarkdown from "../components/MyMarkdown";




const IndexPage: FC = () => {
  const theme = useTheme();

  const [state, setState] = React.useState({
    filterSkills: 'all',
    dialogOpen: false,
    project_license: '',
    language_autocomplete: [],
  });
  const stateRef = React.useRef(state);
  // Avoid conflict when async calls
  const updateState = React.useCallback((update) => {
    stateRef.current = {...stateRef.current, ...update};
    setState(stateRef.current);
  }, [setState]);

  return(
    <Container className='mainContainer'>
      <Seo title="Home" />

      {/* <Title>
        Online profiles
      </Title> */}

      <Card style={{display: 'inline-block', padding: theme.spacing(2)}}>
        <Stack direction={{xs: "column", md: "row"}} spacing={2} alignItems="center" justifyContent="center">
          <ProfileButton label='CV'
            tooltip='Curriculum Vitæ'
            href="/cv_carlos_utrilla-guerrero.pdf"
            color="error"
            icon={<PDFIcon />}
          />
          <ProfileButton label='carlosug'
            tooltip='GitHub profile'
            href="https://github.com/carlosug"
            color="warning"
            icon={<GitHubIcon />}
          />
          <ProfileButton label='carlos utrilla guerrero'
            tooltip='LinkedIn profile'
            href="https://www.linkedin.com/in/carlos-utrilla-guerrero-97ba7b31/"
            color="info"
            icon={<LinkedInIcon />}
          />
          <ProfileButton label='0000-0002-9994-1462'
            tooltip='ORCID profile'
            href="https://orcid.org/0000-0002-9994-1462"
            color="success"
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={OrcidIcon} />
            </Icon>}
          />
                    <ProfileButton label='c.utrilla.guerrero@gmail.com'
            tooltip='Gmail account'
            href="mailto:c.utrilla.guerrero@gmail.com"
            color="secondary"
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={emailIcon} />
            </Icon>}
          />
          {/* <ProfileButton label='Solid pod'
            tooltip='SOLID pod (Social Linked Data)'
            href="https://carlosug.solidcommunity.net/profile/#me"
            color="info"
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={SolidIcon} />
            </Icon>}
          /> */}
        </Stack>
      </Card>

      <div style={{marginTop: theme.spacing(3), textAlign: 'center'}}>
        {short_intro_text}
      </div>



      <Title id='publications'>
        📚️ Publications
      </Title>


      <Card style={{display: 'inline-block', padding: theme.spacing(2)}}>
        <Stack direction={{xs: "column", md: "row"}} spacing={2} alignItems="center" justifyContent="center">
          <ProfileButton label='Google Scholar'
            tooltip='Publications on Google Scholar'
            href="https://scholar.google.com/citations?user=dpMY-4cAAAAJ&hl"
            color="warning"
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={GoogleScholarIcon} />
            </Icon>}
          />
          <ProfileButton label='Research Gate'
            tooltip='Publications on Research Gate'
            href='https://www.researchgate.net/profile/Carlos-Utrilla-Guerrero'
            color='yellow'
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={RgIcon} />
            </Icon>}
          />
                    <ProfileButton label='Zenodo'
            tooltip='Publications on Zenodo'
            href='https://zenodo.org/search?q=metadata.creators.person_or_org.name%3A%22Carlos%20Utrilla%20Guerrero%22&l=list&p=1&s=10&sort=bestmatch'
            color='info'
            icon={<Icon style={{display: 'flex', marginLeft: theme.spacing(1)}}>
              <img src={slideIcon} />
            </Icon>}
          />
        </Stack>
      </Card>


      <Title id='projects' fontWeight='bold'>
      🔬 Latest research projects
      </Title>

      <Grid container spacing={1} alignItems="stretch">
        { projects.map((project: any, key: number) => (
          <Grid item xs={12} md={4}>
            <Card style={{display: 'inline-block', textAlign: 'center', height: '100%'}}>
              <CardHeader
                // avatar={<GitHubIcon />}
                title={project.title}
                titleTypographyProps={{fontSize:'1.1rem', fontFamily:'Roboto'}}
                // titleTypographyProps={{variant: 'subtitle1', style: {fontSize: '1.1rem'} }}
                subheader={<>
                  { project.langs.map((lang: any, key: number) => (
                    <CodeChip lang={lang} key={key}/>
                  ))}
                </>}
                style={{paddingBottom: '0px', textAlign: 'center'}}
              />
               <CardMedia
                component="img"
                height="80"
                image={project.image}
                alt={project.title}
                sx = {{
                  borderRadius: '10%',
                  boxShadow: '0 0 10px 0 rgba(0,0,0,0.2)',
                  margin: 'auto',
                  width: '70%',
                }} />
              <CardContent style={{paddingBottom: '0px', paddingTop: theme.spacing(1)}}>
                <Typography variant="body2" style={{fontSize: "0.75rem", fontFamily: "sans-serif"}}>
                  {project.description}
                </Typography>
              </CardContent>
              <CardActions disableSpacing style={{display: 'block', paddingTop: '0px', textAlign: 'center'}}>
                { project.website_url &&
                  <Tooltip title='Go to the website'>
                    <a href={project.website_url} target='_blank'>
                      <IconButton aria-label="Go to website">
                        <GoToWebsiteIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { project.docs_url &&
                  <Tooltip title='Article'>
                    <a href={project.docs_url} target='_blank'>
                      <IconButton aria-label="Go to documentation">
                        <PDFIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { project.git_url &&
                  <Tooltip title='Source code on GitHub'>
                    <a href={project.git_url} target='_blank'>
                      <IconButton aria-label="GitHub link">
                        <GitHubIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { project.pip_url &&
                  <Tooltip title='Slides'>
                    <a href={project.pip_url} target='_blank'>
                      <IconButton aria-label="Pip link">
                        <CoPresentIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>


      <div style={{marginTop: theme.spacing(3), textAlign: 'center'}}>
        {past_text}
      </div>



      <Title id='courses'>
      🎭 Teaching
      </Title>

      <Grid container spacing={3} alignItems="stretch">
        { courses.map((course: any, key: number) => (
          <Grid item xs={10} md={3}>
            <Card style={{display: 'inline-block', textAlign: 'center', height: '100%'}}>
              <CardHeader
                // avatar={<GitHubIcon />}
                title={course.title}
                titleTypographyProps={{fontSize: '1.1rem'}}
                // titleTypographyProps={{variant: 'subtitle1', style: {fontSize: '1.1rem'} }}
                subheader={<>
                  { course.langs.map((lang: any, key: number) => (
                    <CodeChip lang={lang} key={key}/>
                  ))}
                </>}
                style={{paddingBottom: '0px', textAlign: 'center'}}
              />
              <CardContent style={{paddingBottom: '0px', paddingTop: theme.spacing(1)}}>
                <Typography variant="body2">
                  {course.description}
                </Typography>
              </CardContent>
              <CardActions disableSpacing style={{display: 'block', paddingTop: '0px', textAlign: 'center'}}>
                { course.website_url &&
                  <Tooltip title='Go to the website'>
                    <a href={course.website_url} target='_blank'>
                      <IconButton aria-label="Go to website">
                        <GoToWebsiteIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { course.docs_url &&
                  <Tooltip title='Documentation'>
                    <a href={course.docs_url} target='_blank'>
                      <IconButton aria-label="Go to documentation">
                        <DocsIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { course.git_url &&
                  <Tooltip title='Source code on GitHub'>
                    <a href={course.git_url} target='_blank'>
                      <IconButton aria-label="GitHub link">
                        <GitHubIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
                { course.pip_url &&
                  <Tooltip title='Python library on PyPI'>
                    <a href={course.pip_url} target='_blank'>
                      <IconButton aria-label="Pip link">
                        <PipIcon />
                      </IconButton>
                    </a>
                  </Tooltip>
                }
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>

      <div style={{marginTop: theme.spacing(2), textAlign: 'center'}}>
        {supervising}
      </div>

    <Title id="skills">
      🛠️ Talks and presentations
    </Title>

    <Typography variant="h6" style={{ marginBottom: theme.spacing(0.1), fontFamily: 'fantasy', textAlign: 'justify', fontWeight: 'bold'}}>
      2025:
    </Typography>
    <hr style={{ border: '0.5px solid grey', marginTop: theme.spacing(0.1) }} />
    <ul style={{ textAlign: 'justify'}}>
    <li><LinkLecture href="https://zenodo.org/records/17233417">Can AI resolve the challenges of research software reuse?</LinkLecture> SEPLN International Conference, Oct 2025.</li>
      <li><LinkLecture href="https://zenodo.org/records/14888704">The potential role of generative AI in RSE: Opportunities and Challenges.</LinkLecture> AI in Action: How Researchers Leverage AI, RDA Workshop Feb 2025.</li>
      {/* <li><LinkLecture href="https://zenodo.org/records/11492084">Exploration of AI tools for research software.</LinkLecture> Spring Symposium - AI Education hosted by TU Delft | AI Initiative, June 2024.</li> */}
      {/* <li><LinkLecture href="https://doi.org/10.5281/zenodo.11528182">Automated Extraction of Research Software Installation Instructions from README files.</LinkLecture> NSLP 2024 workshop, May 2024.</li> */}
    </ul>

    <Typography variant="h6" style={{ marginBottom: theme.spacing(0.1), fontFamily: 'fantasy', textAlign: 'justify', fontWeight: 'bold'}}>
      2024:
    </Typography>
    <hr style={{ border: '0.5px solid grey', marginTop: theme.spacing(0.1) }} />
    <ul style={{ textAlign: 'justify'}}>
      <li><LinkLecture href="https://zenodo.org/records/14501603">TU Delft Curso para Candidatos de Doctorado: Gestión de datos de Investigación 101.</LinkLecture> RDA23 Plenary Conference en Costa Rica (Univ. de San Jose), Nov 2024.</li>
      <li><LinkLecture href="https://zenodo.org/records/11492084">Exploration of AI tools for research software.</LinkLecture> Spring Symposium - AI Education hosted by TU Delft | AI Initiative, June 2024.</li>
      <li><LinkLecture href="https://doi.org/10.5281/zenodo.11528182">Automated Extraction of Research Software Installation Instructions from README files.</LinkLecture> NSLP 2024 workshop, May 2024.</li>
    </ul>

    <Typography variant="h6" style={{ marginBottom: theme.spacing(0.1), fontFamily: 'fantasy', textAlign: 'justify', fontWeight: 'bold'}}>
      2023:
    </Typography>
    <hr style={{ border: '0.5px solid grey', marginTop: theme.spacing(0.1) }} />
    <ul style={{ textAlign: 'justify'}}>
      <li><LinkLecture href="https://zenodo.org/records/8158825">What can an open science educator do on teaching and building digital competences in reproducibility?.</LinkLecture> Sheffield University at Teaching Reproducible Research and Open Science Conference, July 2023.</li>
    </ul>
  
    <Typography variant="h6" style={{ marginBottom: theme.spacing(0.1), fontFamily: 'fantasy', textAlign: 'justify', fontWeight: 'bold'}}>
      2022:
    </Typography>
    <hr style={{ border: '0.5px solid grey', marginTop: theme.spacing(0.1) }} />
    <ul style={{ textAlign: 'justify'}}>
    <li><LinkLecture href="https://zenodo.org/records/6588450">Challenges and solutions towards building and visualising FAIR data for traditional games.</LinkLecture> Storytelling - DARIAH Annual Conference 2022 , Athens, Greece; June 2022.</li>
    <li><LinkLecture href="https://www.openscience-maastricht.nl/events/fair-coffee-lecture-25-may-2022/">FAIR Coffee: Visualising FAIR data for traditional games.</LinkLecture> FAIR Coffee Event - Maastricht and (online); May 2022.</li>
    <li><LinkLecture href="https://www.slideshare.net/slideshow/the-importance-of-the-community-of-data-driven-insights-the-road-to-the-science-of-the-future1/251059170">The importance of FAIR and the Community of Data Driven Insights (CDDI) - the road to the science of the future.</LinkLecture> A talk about the Community Data Driven Insight project in Maastricht University, April 2022.</li>
    <li><LinkLecture href="https://riojournal.com/topical_collection/190">FAIR Begins at home: Implementing FAIR via the Community Data Driven Insights.</LinkLecture> RIO Journal - FAIR Data Collection, March 2022.</li>
    <li><LinkLecture href="https://www.slideshare.net/slideshow/online-mbic-open-science-symposium-oct-2020/251381936">FAIR practices being currently implemented in some projects CDDI.</LinkLecture> Online M-BIC Open Science Symposium, January 2022.</li>
    </ul>

    <Title id="bio">
      💬 Bio
    </Title>


      {about_me_text}
      {/* <MyMarkdown>
       Trying markdown
      </MyMarkdown> */}
 <Paragraph style={{textAlign: 'left'}}>
        Below I subjectively rated my techincal skills with scores, please refer to my <LinkPara href="/cv_carlos_utrilla-guerrero.pdf">🗂️ CV</LinkPara> for a better account of how those skills were used.
      </Paragraph>

      <Button variant="text" color="inherit" onClick={() => { updateState({ filterSkills: 'all'}) }} style={{textTransform: 'none'}}>
        💥 All
      </Button>
      { skillsCategories.map((cat: any, key: number) => (
        <Button variant="text" color={cat.color} style={{textTransform: 'none'}}
        onClick={() => { updateState({ filterSkills: cat.title}) }}>
          {cat.emoji} {cat.title}
        </Button>
      ))}

      <Grid container spacing={2} alignItems="stretch" style={{marginTop: theme.spacing(1)}}>
        { skills.map((skill: any, key: number) => {
          const cat: any = skillsCategories.filter(obj => { return obj.title === skill.category[0]; })[0]
          return (<>
            { (state.filterSkills == 'all' || skill.category.includes(state.filterSkills)) &&
            <Grid item xs={12} md={4}>
              <Card style={{textAlign: 'left', height: '100%', padding: theme.spacing(1)}}>
                <CardContent style={{padding: '0px'}}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* ##ch is the size of the largest skill name */}
                    <Typography variant="body2" style={{width: '20ch'}}>
                      {skill.title}
                    </Typography>
                    <Box sx={{ width: '100%', mr: 1 }}>
                      <LinearProgress variant="determinate"
                        value={skill.competency*20}
                        color={cat.color}
                      />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                      <Typography variant="body2" color="text.secondary">{skill.competency}/5</Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          }
        </>)}
        )}
      </Grid>
    </Container>
  )
}
export default IndexPage;